import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = [{
    quote: "Prime Nation's free phone and tablet services have been an absolute <span class='text-brand-coral'>GAME-CHANGER FOR ME</span>. As a student on a tight budget, I couldn't afford expensive devices or hefty monthly bills. The service is reliable, the devices are top-notch, and best of all, it's completely free. I highly recommend Prime Nation to anyone looking for quality tech without breaking the bank.",
    name: 'SARAH W.',
    role: 'PRIME NATION MEMBER'
  }, {
    quote: "Getting my home internet set up through Prime Nation was the <span class='text-brand-coral'>EASIEST PROCESS EVER</span>. The staff treated me with such respect and made sure I understood everything. Now my kids can do their homework online without us worrying about the monthly bill.",
    name: 'MARCUS T.',
    role: 'PRIME NATION MEMBER'
  }];
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="bg-brand-lime py-20 md:py-32 relative overflow-hidden" data-id="element-250">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center relative z-10" data-id="element-251">
        <div className="max-w-[1000px] w-full relative" data-id="element-252">
          <div className="relative min-h-[350px] md:min-h-[300px] flex flex-col justify-center" data-id="element-253">
            <AnimatePresence mode="wait" data-id="element-254">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -20
            }} transition={{
              duration: 0.3
            }} className="text-center" data-id="element-255">
                <p className="font-display text-[32px] md:text-[56px] leading-[1.1] text-brand-black uppercase mb-12" dangerouslySetInnerHTML={{
                __html: testimonials[currentIndex].quote
              }} data-id="element-256" />

                <div className="flex flex-col items-center justify-center" data-id="element-257">
                  <div className="w-[60px] h-[2px] bg-brand-black mb-6" data-id="element-258"></div>
                  <p className="font-display text-2xl text-brand-black tracking-wider uppercase" data-id="element-259">
                    {testimonials[currentIndex].name}
                  </p>
                  <p className="text-sm text-brand-black/70 font-mono tracking-widest mt-2 uppercase" data-id="element-260">
                    {testimonials[currentIndex].role}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Carousel Controls */}
          {testimonials.length > 1 && <div className="flex justify-center gap-4 mt-12" data-id="element-261">
              <button onClick={prev} className="w-12 h-12 rounded-full border-2 border-brand-black flex items-center justify-center text-brand-black hover:bg-brand-black hover:text-brand-lime transition-colors" aria-label="Previous testimonial" data-id="element-262">
                <ChevronLeft size={24} data-id="element-263" />
              </button>
              <button onClick={next} className="w-12 h-12 rounded-full border-2 border-brand-black flex items-center justify-center text-brand-black hover:bg-brand-black hover:text-brand-lime transition-colors" aria-label="Next testimonial" data-id="element-264">
                <ChevronRight size={24} data-id="element-265" />
              </button>
            </div>}
        </div>
      </div>
    </section>;
}